import React from 'react';

import { styled } from 'styled-components';

interface LeftContainerProps {
  children: React.ReactNode;
}

const TemplateCreation = styled.div`
  display: flex;
  flex-direction: column;
  height: 70%;
  flex: 1;
  gap: 2rem;
  width: 40vw;
  padding-right: 24px;
`;
const LeftContainer = ({ children }: LeftContainerProps) => {
  return <TemplateCreation>{children}</TemplateCreation>;
};

export default LeftContainer;
